<div *ngIf="RTRecordsGridData.length > 0">
	<!-- Energy Format Info (only show if mixed formats detected) -->
	<div *ngIf="energyAnalysis && energyAnalysis.recommendation === 'both'" class="panel panel-info">
		<div class="panel-body">
			<i class="fa fa-info-circle"></i>
			<strong>Mixed Energy Formats Detected:</strong>
			{{energyAnalysis.legacyCount}} legacy records (Phase A/B/C),
			{{energyAnalysis.newCount}} new format records (Total kWh)
		</div>
	</div>

	<div class="panel panel-default">
		<div class="panel-heading">
			<h4 class="panel-title">PolarLink Real-Time Records</h4>
		</div>
		<div class="panel-body">
			<app-grid-v2 #rtRecordsGrid
				translateHeaders="true"
				id="PlinkRTRecordsGrid"
				[modelId]="device.deviceid"
				[columns]="RTRecordsGridColumns"
				[data]="RTRecordsGridData"
				[settings]="settings"
				(onCellClicked)="onRTRecordCellClicked($event)"
			></app-grid-v2>
		</div>
	</div>
</div>

<div *ngIf="RTRecordsGridData.length == 0">
	<div class="panel panel-default">
		<div class="panel-body">
			<strong>No PolarLink Real-Time Records Found in Selected Period!</strong>
		</div>
	</div>
</div>
